var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-2 pa-1"},[_c('b-card-text',[_c('BaseBForm',{ref:"formSearch",attrs:{"model":_vm.data}}),_c('b-btn',{staticClass:"ml-auto mt-2 white--text",attrs:{"depressed":"","variant":"primary-sub1"},on:{"click":this.handleSearch}},[_vm._v(" Αναζήτηση ")])],1)],1),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }